export default __webpack_public_path__ + "static/media/editar.544da713.svg";